import { connect } from 'react-redux';

// Components:
import PriceSelector from '../components/PriceSelector';

// Actions:
import { startTyping, stopTyping } from '../store/view/slice';

// Constants:
import { PRICE_PRESETS } from '../store/certificate/constants';

// Selectors:
import { setPaymentAmount } from '../../../store/payment/reducer';
import { getPaymentAmount } from '../../../store/payment/selectors';
import { getIsCertificateCreated } from '../store/certificate/selectors';

// Hocs:
import withMobile from '../hocs/withMobile';

const mapStateToProps = (state) => ({
  value: getPaymentAmount(state),
  presets: PRICE_PRESETS,
  isOrderCreated: getIsCertificateCreated(state),
});

const mapDispatchToProps = (dispatch) => ({
  setValue: (payload) => dispatch(setPaymentAmount(payload)),
  setStartTyping: () => dispatch(startTyping()),
  setStopTyping: () => dispatch(stopTyping()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(PriceSelector));
